<template>
    <div>
      <b-card no-body class="overflow-hidden" >
        <b-row no-gutters>
          <b-col md="6">
            <b-card-img src="/static/icons/logo.svg" class="rounded-0 justify-content-sm-center"></b-card-img>
          </b-col>
          <b-col md="6">
            <b-card-body v-if="vid">
              <b-button v-for="(item) in buttons"
                        :key="item.name"
                        @click="item.m(vid)"
                        :variant="item.variant"
                        :title="item.description"
                        class="col-12">
                <h3>{{item.name}}
                  <i :class="item.icon"></i>
                </h3>
              </b-button>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>

    </div>
</template>

<script>
  import axios from "@/store/vue-axios"
    export default {
        name: "luma-actions-vserver",

        data:()=>({
            buttons:[
                {
                    name:'Start',
                    icon:'fa fa-play',
                    description:'ERKLÄR',
                    variant:'primary',
                    m:  (y)=> {
                        const x = axios.post("/datacenter/vservers/"+y+"/start")
                    }
                },
                {
                    name:'Restart',
                    icon:'fa fa-recycle',
                    description:'ERKLÄR',
                    variant:'warning',
                    m:  (y)=> {
                        const x = axios.post("/datacenter/vservers/"+y+"/restart")
                    }
                },
                {
                    name:'Shutdown',
                    icon:'fa fa-power-off',
                    description:'ERKLÄR',
                    variant:'danger',
                    m: (y)=> {
                        const x = axios.post("/datacenter/vservers/"+y+"/shutdown")
                    }
                },
                {
                    name:'Stop',
                    icon:'fa fa-stop',
                    description:'ERKLÄR',
                    variant:'outline-danger',
                    m: (y)=> {
                        const x = axios.post("/datacenter/vservers/"+y+"/stop")
                    }
                },

                {
                    name:'Neuinstallieren',
                    icon:'fa fa-cogs',
                    description:'ERKLÄR',
                    variant:'outline-warning',
                    m: (y)=> {
                        const x = axios.post("/datacenter/vservers/"+y+"/reinstall")
                    }
                }
            ]
        }),
        computed:{
            vid(){
                return this.$route.params.id
            },
        }
    }
</script>

<style scoped>
  button{
    margin:8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-actions-vserver.vue